import table from './src/table.vue'

export default table
